import { render, staticRenderFns } from "./RecueilInfos.vue?vue&type=template&id=0fbeb786"
import script from "./RecueilInfos.vue?vue&type=script&lang=js"
export * from "./RecueilInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports